import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  ButtonBar, IntroScreenHeader, SectionDescription
} from '../../components';

const sections = [
  {
    title: 'Verify Personal Info',
    description: 'Confirm your name, date of birth, address, and contact details'
  },
  {
    title: 'Burial or Cremation',
    description: 'Choose your preferred method of body disposition'
  },
  {
    title: 'Ceremony Preferences',
    description: 'Discuss your wishes for the funeral service, including music, readings, and speakers'
  },
  {
    title: 'Obituary Instructions',
    description: 'How do you want your life to be remembered?'
  },
  {
    title: 'Financial Planning',
    description: 'Ensure funds are available for funeral costs and other expenses'
  }
];

export function NewFAIntroScreen() {
  const navigate = useNavigate();
  
  const handleCancel = useCallback(() => {
    navigate('/home');
  }, [ navigate ]);

  const handleNext = useCallback(() => {
    navigate('verify');
  }, [ navigate ]);

  return (
    <div className="new-fa-intro-screen screen-container">
      <IntroScreenHeader
        title="What we'll cover"
        description="This guided process will help you select funeral arrangements in just a few simple steps."
      />
      {sections.map((section, index) => (
        <SectionDescription key={index} title={section.title} description={section.description} />
      ))}
      <ButtonBar 
        handlePrimary={handleNext}
        handleSecondary={handleCancel}
        primaryText="Get Started"
        secondaryText="Cancel"
      />
    </div>
  );
}

